import mammoth from "mammoth"
import { useEffect, useState } from "react"

interface DocxViewerComponentProps {
  url: string
}

const DocxViewerComponent = ({ url }: DocxViewerComponentProps) => {
  const [html, setHtml] = useState("")
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let timeoutId: NodeJS.Timeout
    const controller = new AbortController()

    const fetchDocument = async () => {
      window.parent.postMessage({ url: url })
      if (!url) return
      // controller is now declared outside
      const controller = new AbortController()
      timeoutId = setTimeout(() => controller.abort(), 10000) // 10 seconds timeout

      try {
        setLoading(true)
        setError(null)
        const response = await fetch(url, {
          headers: {
            Accept:
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          },
          signal: controller.signal,
        })
        clearTimeout(timeoutId)

        if (!response.ok) {
          throw new Error("Failed to fetch document")
        }
        const arrayBuffer = await response.arrayBuffer()
        const { value } = await mammoth.convertToHtml({ arrayBuffer })
        setHtml(value)
      } catch (error) {
        if (error instanceof Error) {
          if (error.name === "AbortError") {
            console.error("Fetch request timed out")
            setError("The request timed out. Please try again.")
          } else {
            console.error("Error fetching document:", error)
            setError("Failed to load the document. Please try again.")
          }
        } else {
          console.error("Unknown error", error)
          setError("An unknown error occurred. Please try again.")
        }
      } finally {
        setLoading(false)
      }
    }

    fetchDocument()

    return () => {
      clearTimeout(timeoutId)
      controller.abort()
    }
  }, [url])

  return (
    <div>
      {loading && <div>Loading document...</div>}
      {error && <div className="error">{error}</div>}
      {!loading && !error && (
        <div
          className="docx-viewer"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
          dangerouslySetInnerHTML={{ __html: html }}
        />
      )}
    </div>
  )
}

export default DocxViewerComponent
